import React from "react";
import { useParams } from "react-router-dom";

const LiveClass = () => {
  const { meetingId } = useParams();
  const joinUrl = `https://test-bbb.educonnection.nl/bigbluebutton/api/join?meetingID=${meetingId}&password=studentpw&fullName=Student`;

  return (
    <iframe
      src={joinUrl}
      width="100%"
      height="100vh"
      frameBorder="0"
      allowFullScreen
      title="Live Class"
    />
  );
};

export default LiveClass;